<template>
    <div style="padding: 0px;padding-bottom: 50px;">
        <el-breadcrumb separator-class="el-icon-arrow-right">
        </el-breadcrumb>
        <el-row :gutter="20">
            <el-card shadow="always" style="height: 100%;">
                <el-card shadow="nerver" class="devABC">
                    <span v-for="A in ABClist" :key="A" :class="getABCColor(A)" @click="clickABC(A)">{{ A }}</span>
                </el-card>

                <el-tabs v-model="activeName">
                    <el-tab-pane label="全部游戏" name="first">

                        <el-card shadow="nerver" v-for="game in currentListFull" :key="game.GameID" class="gamecard"
                            @click.native="selectaGame(game)">
                            <img :src="game.GameIcon" class="gameicon1">
                            <div style="padding: 14px 0px;">
                                <div class="gamename">{{ game.GameName }}</div>
                            </div>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="网络游戏" name="second">
                        <el-card shadow="nerver" v-for="game in currentListPC" :key="game.GameID" class="gamecard"
                            @click.native="selectaGame(game)">
                            <img :src="game.GameIcon" class="gameicon1">
                            <div style="padding: 14px 0px;">
                                <div class="gamename">{{ game.GameName }}</div>
                            </div>
                        </el-card>
                    </el-tab-pane>
                    <el-tab-pane label="手机游戏" name="third">
                        <el-card shadow="nerver" v-for="game in currentListMobile" :key="game.GameID" class="gamecard"
                            @click.native="selectaGame(game)">
                            <img :src="game.GameIcon" class="gameicon1">
                            <div style="padding: 14px 0px;">
                                <div class="gamename">{{ game.GameName }}</div>
                            </div>
                        </el-card>
                    </el-tab-pane>

                </el-tabs>

            </el-card>
        </el-row>


    </div>
</template>

<script>
import Schart from "vue-schart";
import bus from "../common/bus.js";
import netutil from "../common/netutil.js";

export default {
    name: "games",
    data() {
        return {
            activeName: "first",
            ABClist: ["全部", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"],
            activeABC: "全部",
            fullGames: [],
            currentListFull: [],
            currentListPC: [],
            currentListMobile: [],
            serchName: '',

        };
    },
    components: {
        Schart
    },
    computed: {
        role() {
            return "--";
        }
    },
    created() {
        this.loadGameList();

    },
    activated() {

    },
    deactivated() {

        bus.$off("collapse", this.handleBus);
    },
    methods: {
        loadGameList() {
            let games = JSON.parse(localStorage.getItem("GameList"));
            if (!games||games.length == 0) {
                this.getGameList(500);
            }
            else {
                this.fullGames = games;
                this.currentListFull = games;
                this.currentListPC = games;
                this.currentListMobile = games;
            }

        },
        getGameList(max) {
            var self = this;
            var param = {
                max: max
            };
            netutil.get("public/getgamelist", param,
                function (data) {

                    self.fullGames = data.data0;
                    self.currentListFull = data.data0;
                    self.currentListPC = data.data0;
                    self.currentListMobile = data.data0;

                },
                function (msg) {

                });
        },
        selectaGame(game) {
            this.$router.push('/selectgame?id=' + game.GameID);
        },
        getABCColor(a) {
            return (a == this.activeABC) ? "ABC ABCActive" : "ABC";
        },
        clickABC(A) {
            for (let i = 0; i < this.ABClist.length; ++i) {
                if (A == this.ABClist[i]) this.activeABC = this.ABClist[i];
            }

            if ("全部" == A) {
                this.currentListFull = JSON.parse(JSON.stringify(this.fullGames));
                this.currentListPC = JSON.parse(JSON.stringify(this.fullGames));
                this.currentListMobile = JSON.parse(JSON.stringify(this.fullGames));

            }
            else {
                this.currentListFull = [];
                this.currentListPC = [];
                this.currentListMobile = [];
                for (let i = 0; i < this.fullGames.length; ++i) {
                    if (this.fullGames[i].ABC.toUpperCase() == A.toUpperCase()) {
                        this.currentListFull.push(this.fullGames[i]);
                        this.currentListPC.push(this.fullGames[i]);
                        this.currentListMobile.push(this.fullGames[i]);
                    }
                }
            }

        },
        handleClick() {

        },

        handleBus(msg) {

        },

    }
};
</script>


<style scoped>
.el-row {
    margin-bottom: 20px;
}


.demo-tabs>.el-tabs__content {
    padding: 20px;
    color: #6b778c;
    font-size: 32px;
    font-weight: 600;
}

.titleImg {
    float: left;
    margin-right: 30px;
}



.gamecard {
    width: 140px;
    height: 170px;
    margin: 3px;
    border: #ffffff;
    cursor: pointer;
    float: left;

}

.gameicon1 {
    width: 100px;
    height: 100px;
    padding-left: calc(50% -70px);
    border-radius: 15px;
}

.gamename {
    font-size: 16px;
    width: 100%;
    margin-top: -10px;
    text-align: center;

}


.shareicon {
    padding-top: 24px;
    font-size: 20px;
}

.leftgame {
    width: 100%;
    height: 95px;
    margin-bottom: 5px;
    display: flex;
    cursor: pointer;

}

.leftgame:hover {
    padding-left: 5px;

}



.sgametitle1 {
    font-size: 22px;
    padding: 6px;
    font-weight: 600;
    color: #363636;
}

.sgametitle2 {
    font-size: 16px;
    padding-left: 6px;
    color: #8b8b8b;
}

.moregamesbtn {
    width: 100%;
    height: 50px;
    margin-top: 5px;
    border-radius: 15px;
    background-color: #ff8800;
    font-size: 20px;
}


.devABC {
    background-color: #dbdbdb;
    border-radius: 30px;
    height: 60px;
}

.ABC {
    padding-left: 12px;
    padding-right: 12px;
    padding-bottom: 20px;
    color: #717171;
    font-size: 20px;
    cursor: pointer;
}

.ABC:hover {
    color: #ff8800;
}

.ABCActive {
    color: #ff8800;
}
</style>
